import { AdvanceBreadcrumb } from '@/components/Breadcrumb';
import { Card, Tabs } from 'antd';
import React from 'react';
import CustomDrive from './CustomDrive';
import DriveMarket from './DriveMarket';
import './style.less';

export interface DriveImageProps {}

export interface ProductType {
  id: string;
  product_id: string;
  name: string;
  node_type: string;
  platform: string;
  created_at: number;
  category_name: string;
}

// const NodeTypeMap: {[key: string]: string} = {
//   0: '未知类型',
//   1: '网关',
//   2: '直连设备',
//   3: '网管子设备',
// }

const DriveImage: React.FC<DriveImageProps> = () => {
  return (
    <>
      <AdvanceBreadcrumb
        title="驱动市场"
        describe="驱动协议市场为您提供丰富的协议驱动资源，用户可根据实际接入需求按需下载所需协议。"
        background={require('@/assets/images/product-background.png')}
        key="DriveImage"
      />
      <Card styles={{ body: { padding: 0 } }}>
        <Tabs
          className="drive-image mt20"
          type="card"
          items={[
            {
              key: '1',
              label: '驱动市场',
              children: <DriveMarket></DriveMarket>,
            },
            {
              key: '2',
              label: '自定义',
              children: <CustomDrive></CustomDrive>,
            },
          ]}
        />
      </Card>
    </>
  );
};

export default DriveImage;
